module.exports = __webpack_public_path__ + "img/car2.dde8c77a.png";